import React from 'react';
import { cn } from '@/lib/utils';

interface OvertimeTypeBadgeProps {
  name: string;
  colour: string;
  className?: string;
}

/**
 * Coloured pill badge used to display an overtime type on a timesheet row.
 * The background uses the type's configured hex colour; text is always white.
 */
export const OvertimeTypeBadge: React.FC<OvertimeTypeBadgeProps> = ({ name, colour, className }) => {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium text-white whitespace-nowrap',
        className
      )}
      style={{ backgroundColor: colour }}
    >
      {name}
    </span>
  );
};
